import React, { useContext, useEffect, useState } from 'react'
import FileUpload from '../../../components/upload/upload-file'
import Buttons from '../../../components/buttons/buttons'
import './uploadFiles.css'
import axios from 'axios'
import Noresult from '../../../components/noresult/noresult'
import { DocumentIconNames, formatTimestamp } from '../../../Global'
import { FILE_SUBMIT_SUCCESS_MSG, BASE_URL, DELETE_MSG} from '../../../configuration'
import Alert from '../../../components/alert/alert'
import { PopupCloseContext, UserInitalValue } from '../../../shared/contexts/popupclose-context'
import PageOverlay from '../../../pageoverLay/pageoverLay'
import { AuthContext } from '../../../shared/contexts/AuthContextProvider'

const UploadDocuments = () => {
    const { accessToken } = useContext(AuthContext)
      const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
    const [files, setFiles] = useState<any>([])
    const [progress,setProgress] = useState<number>(0)
    const [uploadStatus,setUploadStatus] = useState<boolean>(false)
    const [isUploading, setIsUploading] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const[deleteItem,setDeleteItem] = useState<any>()
    const [loading, setLoading] = useState<boolean>(true)
    const handleFileChange = (updatedAttachments: any) => {
        const existingFiles = data?.map((x: any) => x?.file_name)
    const hasDuplicate = updatedAttachments.some((attachment: any) => existingFiles.includes(attachment?.name))
    if (hasDuplicate) {
      setduplicateError(true)
    } else {
        setduplicateError(false)
          setFiles(updatedAttachments)
          setProgress(0)
        }
    }
const [data,setData] = useState<any>([])
const [uploadPercentage, setUploadPercentage] = useState(0)
const [duplicateError, setduplicateError] = useState<boolean>(false)
const getData = async()=>{
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    }
const respose = await axios.get(`${BASE_URL}/get_files`, { headers })
setData(respose.data.response)
setLoading(false)
}
useEffect(()=>{
 getData()
},[accessToken])
const uploadFiles = async () => {
    if (!files || files.length === 0) return
    const formData = new FormData()
    for (const file of files) {
        formData.append('files', file)
    }
    try {
        setLoading(true)
        setProgress(0)
        setUploadStatus(false)
        setIsUploading(true)
        const response = await axios.post(`${BASE_URL}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${accessToken}`
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                )
                setProgress(percentCompleted) 
            }
        })
        setUploadStatus(true)
        await getData()
        setLoading(true)
    } catch (error) {
        console.error('Error uploading files:', error)
    }
    finally {
        setIsUploading(false)
        setLoading(false)
    } 
}
useEffect(() => {
    if (uploadStatus) {
      const timer = setTimeout(() => {
        setUploadStatus(false)
        setIsUploading(false)
        setFiles([])
      }, 5000) // 5 seconds
      return () => clearTimeout(timer)
    }
  }, [uploadStatus])
  const onDelete = (item: any) => {
     setDeleteItem(item)
    setShowAlert(true)
    setMultiplePopup('')
}
const onClickAlert = async (button: string) => {
    if (button === 'Yes') {
        setShowAlert(false)
        if (deleteItem) {
            setLoading(true)
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                }
                const response = await axios.delete(`${BASE_URL}/delete`, {
                    headers,
                    data: { filename: deleteItem.file_name }, 
                })
                const data = response.data
                setDeleteItem(null)
                await getData()
            } catch (error) {
                console.error('Error deleting file:', error)
            } finally {
                setLoading(false)
            }
        }
    } else {
        setShowAlert(false)
        setDeleteItem(null)
    }
}

    return(
        <>
         {loading && <PageOverlay />}
            {uploadStatus && <div className="successmsg d-flex align-items-center justify-content-center"><span className="icon-cloud-checked font-18 pe-2 title-color8"></span>{FILE_SUBMIT_SUCCESS_MSG}</div>}
            
            <div className="w-100 py-3 d-flex flex-column gap-3">
                <div className="card border-radius2 shadow">
                    <div className="card-body p-3">
                        <div className='d-flex flex-column align-items-center justify-content-center gap-2'>
                            <FileUpload
                                inputProps={{
                                    id: 'attachfiles',
                                    name: 'Description',
                                    className: 'segoeui-medium font-13 darktext mb-2',
                                }}
                                label='Attach File(s)'
                                infoClassName='tool-tip tooltip-top color-primary font-12 sourcesanspro'
                                info='AttachFile'
                                infoIcon='icon-info'
                                isInfo
                                files={files}
                                setFiles={setFiles}
                                data={data}
                                onFileChange={handleFileChange}
                                formClassName='form-vertical segoeui-medium font-12'
                                hintClassName='color-primary'
                                hintTextClassName='font-13 sourcesanspro subtitle-color3'
                                noteClassName='color-primary'
                                // hint='Upload files in .png, .jpeg, .xlsx, .txt .pdf formats. Special characters should not be used in document names. The maximum file size is 25 MB, and you can upload up to 10 files per screen.'
                                hint='Upload files in .pdf formats. Special characters should not be used in document names. The maximum file size is 25 MB, and you can upload up to 10 files per screen.'
                            // note='Screenshots need to be saved locally before uploading into system.'
                            />
                            <Buttons
                                label={isUploading ? 'Uploading...' : 'Upload'}
                                className='btn-sm segoeui-semibold font-13 d-flex align-items-center btn-primary whitetext'
                                type="button"
                                onClick={uploadFiles}
                                disabled={isUploading}
                            />

                        </div>
                    </div>
                </div>
                <div className="card  border-radius2 shadow">
                    <div className="card-body">
                        <div className="status-table">
                            <table>
                                <thead >
                                    <tr className='row-header'>
                                        <th>Name</th>
                                        <th>State</th>
                                        <th>Submitted On</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data?.length > 0 && (
                                        data?.map((row: any, index: number) => (
                                            <tr key={index}>
                                                <td>
                                                    <span className={`me-1 ${DocumentIconNames(row.file_name)}`}></span>
                                                    {row.file_name}
                                                </td>
                                                <td>{row.state}</td>
                                                <td>{formatTimestamp(row.submitted_on)}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {row.status_detail}
                                                        <Buttons
                                                            label="Delete"
                                                            aria-label="Delete"
                                                            icon="icon-trashbin mandatory me-xl-1 font-12"
                                                            className='btn-xs font-0 btn-border-radius3 ms-auto color-primary text-nowrap'
                                                            onClick={() => { onDelete(row) }}
                                                        />
                                                    </div>
                                                </td>

                                            </tr>
                                        )))}
                                </tbody>

                            </table>
                            {data && data?.length === 0 && (
                                <div className='min-h-100 d-flex align-items-center justify-content-center w-100'>
                                    <Noresult />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showAlert && (
                <Alert message={DELETE_MSG} yes='Yes' cancel='No' className="alert-info"
                    onClick={onClickAlert}
                    btn1iconclassNmae='icon-rb-checked  font-11 pe-1'
                    btn2iconclassNmae='icon-rb-close  font-11 pe-1'
                    btn1className="btn-border-radius-3 px-2 btn-primary whitetext poppins-medium font-12 text-uppercase btn-xs"
                    btn2classNmae="btn-border-1 btn-border-radius-3 px-2  text-color-5 poppins-medium font-12 text-uppercase btn-xs"
                />
            )}
        </>
    )
}

export default UploadDocuments


